

//引入
import request from "../utils/request";
const api = {

    //小区动态
    xqdtquerylist: function (params) {

        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwygkgs/xqdtquerylist",
        });
    },

    //服务承诺
    fwcnquerylist: function (params) {
        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwygkgs/fwcnquerylist",
        });
    },
    //维修政策
    wxzcquerylist: function (params) {
        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwygkgs/wxzcquerylist",
        });
    },
    //其他公示
    qtgsquerylist: function (params) {
        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwygkgs/qtgsquerylist",
        });
    },
    //公示收益
    ggsyquerylist: function (params) {
        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwygkgs/ggsyquerylist",
        });
    },

    //公示详情
    gkgsinfo: function (params) {
        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwygkgs/gkgsinfo",
        });
    },
}

export default api;